module.exports = __webpack_public_path__ + "media/images/landing/people_full_old_better-f7c6568ad9d4a5390521a869a4b2c4cf.png";